import { BetAreaPanel } from './BetArea';
export const AndarBaharBetAreaPanel = () => {
    return <BetAreaPanel />;
};
